// extracted by mini-css-extract-plugin
export default {"main_div":"YogaModal_main_div__5Iqw9","error_msg":"YogaModal_error_msg__Kilsm","previewContainer":"YogaModal_previewContainer__nikLF","previewImage":"YogaModal_previewImage__R2WT2"};